module.exports = __webpack_public_path__ + "static/media/car-woman.fb1e7b23.png";